import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ChangeOrgModalNew = ({ open, setOpen  }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))
     const [orgs, setOrgs] = useState()
    const navigate = useNavigate()
    const {route_id} = useParams()
    const {call_id} = useParams()
      const [err_msg, setErrorMsg] = useState(null);
      const [loader, setLoader] = useState(false);
  const changeOrganization = async (org_id) => {
    try {
      let org = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "get-organization",
        { orgId: org_id }
      );
      localStorage.setItem(
        "organization",
        JSON.stringify(org.data.organization)
      );

      window.location.reload()
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

   const getAllOrgs = async () => {
    setLoader(true)
      let orgs = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "get-organizations",
        {
            userId: JSON.parse(localStorage.getItem('user')).userId.S
        }
      );
      console.log('orgs',orgs)
      setOrgs(orgs.data)
      setLoader(false)
    }
  
    useEffect(() => {
     getAllOrgs()
    }, []);
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Alert !!</div>


        <div className="lg:text-[14px] text-[13px] text-center mb-2" >
        Oops! We couldn't find a record for {route_id ? 'route' : 'call'} <span className="font-bold"> {route_id || call_id}</span> in <span className="font-bold">{JSON.parse(localStorage.getItem('organization'))?.organization_name?.S}</span> , 
        Is it possible the URL is incorrect or that you mean to be logged in as a different organization? 
        If you need help, please <a className="text-blue-800 hover:underline" href='mailto:hello@twilanswer.com'>contact support</a>."

        
        </div>

        <div>
              <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        value={
                          user?.relatedOrgs.L.filter(
                            (e) =>
                              e?.M.org_id.S ===
                              JSON.parse(localStorage.getItem("organization")).orgId.S
                          )[0]?.M.org_id.S
                        }
                        onChange={(f) => {
                          changeOrganization(f.target.value);
                        }}
                        className="mb-2 bg-[#F7F7F8]"
                        sx={{
                          fontSize: "13px",
                          padding: "2px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          "& .MuiSelect-select": {
                            padding: "2px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        {user?.relatedOrgs.L.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.M.org_id.S}>{orgs?.find((e)=> e.orgId.S === item.M.org_id.S)?.organization_name.S}</MenuItem>
                          );
                        })}
                      </Select>
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
      {loader ? (
          <CircularProgress size={"1.0rem"} sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
      ): (
        <div className="flex items-center justify-center space-x-3 mt-4">
          <Button
          sx={{
            textTransform: "none",
            bgcolor: "rgba(236,72,92,0.1)",
            color: "rgba(236,72,92,1)",
            py: "6px",
            px: "30px",
            borderRadius: "7px",
            
            fontSize: { lg: "14px", xs: "13px" },
            width: "fit",
          }}
          onClick={()=> {
            
            localStorage.clear()
            navigate('/login')
          }}
        >
          Logout
        </Button>

        <Button
          sx={{
            textTransform: "none",
            bgcolor: "#605BFF",
            color: "white",
            py: "6px",
            px: "30px",
            borderRadius: "7px",
            
            fontSize: { lg: "14px", xs: "13px" },
            width: "fit",
          }}
          onClick={()=> {
            
            {route_id ? (
                navigate('/dashboard/call-routings')
            ): (
                navigate('/dashboard/')
            )}
          }}
        >
          Go to {route_id ? 'routes' : 'dashboard'}
        </Button>

</div>        
      )}
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default ChangeOrgModalNew;
